/* ONEBAR TRADING — global behaviors shared by obt-* sections:
   light/dark toggle persistence, scroll-reveal, ambient atmosphere drift.
   Self-contained, dependency-light (GSAP optional). Safe to load on every page. */
(function () {
  var root = document.documentElement;

  /* ---- theme toggle (persisted) ---- */
  function apply(t) { root.setAttribute('data-theme', t); }
  try { apply(localStorage.getItem('obt-theme') || 'light'); } catch (e) {}
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-obt-theme-toggle]');
    if (!t) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    apply(next);
    try { localStorage.setItem('obt-theme', next); } catch (err) {}
  });

  /* Internal home links bypass the first-visit gate. The gate is an entrance,
     never the destination of a logo or breadcrumb click. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-obt-home-link]');
    if (!link) return;
    try { sessionStorage.setItem('obtGateSeen', '1'); } catch (err) {}
    try { localStorage.setItem('obtGateSeen', '1'); } catch (err) {}
  });

  /* ---- scroll reveal ----
     Owned by obt-motion.js. It used to live here, with a single global
     setTimeout that revealed EVERY .obt-reveal on the page 2.5s after
     DOM-ready. On a 13,000px homepage that meant all 23 reveals had
     already fired before the visitor scrolled one pixel, so the site
     had no scroll motion at all. obt-motion.js arms the failsafe per
     element and only rescues elements that are actually on screen.
     This shim stays so a page that somehow loads obt-global.js without
     obt-motion.js still shows its content. */
  function reveals() {
    if (window.obtMotionScan) return;
    document.querySelectorAll('.obt-reveal, .obt-spine').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  /* ---- ambient atmosphere drift (GSAP optional) ---- */
  function atmosphere() {
    if (!window.gsap || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.utils.toArray('.obt-atmos__b').forEach(function (b, i) {
      gsap.to(b, { x: '+=26', y: '+=20', rotation: (i % 2 ? 6 : -6),
        duration: 7 + i * 1.4, ease: 'sine.inOut', repeat: -1, yoyo: true });
    });
  }

  function init() { reveals(); atmosphere(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', atmosphere);
})();
